export default function* rootSaga() {
  yield [];
}



// WEBPACK FOOTER //
// ./src/sagas/index.js